<script setup lang="ts">
import { addScheme } from '@clovyr/pollen/remote_exec';

import { useAppStatus } from '@/composables/useAppStatus';
import { useRemoteExec } from '@/composables/useRemoteExec';

import type { RequestConfig, RequestTransformParams } from './finder_types';

const props = defineProps<{
  id: string;
}>();

const deploymentID = toRef(props, 'id');
const { deployment, app, isRunning } = useAppStatus(deploymentID);

const request: RequestConfig = {
  baseUrl: '',
  transformRequest: (req: RequestTransformParams) => {
    const { host, accessKey } = useRemoteExec(deployment.value, app.value);
    req.url = addScheme(host) + `/_leaf/api/finder`;
    req.headers = {
      Authorization: `Bearer: ${accessKey}`,
    };
    return req;
  },
};

const features = Object.values({
  EDIT: 'edit',
  NEW_FILE: 'newfile',
  NEW_FOLDER: 'newfolder',
  PREVIEW: 'preview',
  ARCHIVE: 'archive',
  // UNARCHIVE: 'unarchive',
  SEARCH: 'search',
  RENAME: 'rename',
  UPLOAD: 'upload',
  DELETE: 'delete',
  // FULL_SCREEN: 'fullscreen',
  DOWNLOAD: 'download',
  // LANGUAGE: 'language',
});

onMounted(() => {
  if (!isRunning.value) {
    return;
  }

  const { ensureHostLogin } = useRemoteExec(deployment.value, app.value);
  void ensureHostLogin();
});
</script>

<template>
  <!-- eslint-disable-next-line vue/no-undef-components -->
  <VueFinder v-if="isRunning" :request :features />
</template>

<style scoped></style>
